'use client'

import Script from 'next/script'
import { useRef } from 'react'

type MktoForms2 = {
	whenReady: (callback: () => void) => void
}

type RevenueHeroInstance = {
	schedule: (target: string) => void
}

declare global {
	// defined by scheduler.min.js, available by the time this script's onLoad fires
	const RevenueHero: new (config: { routerId: string }) => RevenueHeroInstance
	interface Window {
		hero?: RevenueHeroInstance
		MktoForms2?: MktoForms2
	}
}

type RevenueHeroSchedulerProps = {
	routerId: string
	marketoFormId: number
}

export const RevenueHeroScheduler = ({ routerId, marketoFormId }: RevenueHeroSchedulerProps) => {
	const scheduledRef = useRef(false)

	return (
		<Script
			id="revenue-hero-scheduler"
			strategy="lazyOnload"
			src="https://assets.revenuehero.io/scheduler.min.js"
			onLoad={() => {
				let attempts = 0
				const run = () => {
					if (scheduledRef.current) return

					// Poll for MktoForms2 to be available
					if (!window.MktoForms2) {
						if (attempts++ < 100) return setTimeout(run, 100)
						throw new Error('MktoForms2 not defined')
					}

					scheduledRef.current = true
					window.MktoForms2.whenReady(() => {
						window.hero = new RevenueHero({ routerId })
						window.hero.schedule(`#mktoForm_${marketoFormId}`)
					})
				}
				run()
			}}
		/>
	)
}
